module.exports = __webpack_public_path__ + "769187ff6568c4bafdb94a520b295071.pdf";